// extracted by mini-css-extract-plugin
module.exports = {"answer":"UXSvmd","container":"_2ksvzo","question":"PlxrWX"};